import React from 'react';
import './styles.css';
import {
    catalogos, 
    procesos, 
    reportes, 
    tools
} from './NOMINA/ImagenesNomina'

export default function DescripcionNominaFondo(props){


    return(<>
     <div className='contenedorDescripcionNominaB'>
        <div className='contenedorGeneralDescripcionNominaB'>
        <div className='contenedorTituloDescripcionNominaB'>
            <p>¿QUÉ MÓDULOS PODRÁS ENCONTRAR?</p>
        </div>
        <div className='caracteristicasDescripcionNominaB'>
            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionNominaB'>
                    <img src={catalogos}/>
                </div>
                <div className='contenedorDescripcionNominaBImagen'>
                    <p>Catálogos</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionNominaB'>
                    <img src={procesos}/>
                </div>
                <div className='contenedorDescripcionNominaBImagen'>
                    <p>Procesos</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionNominaB'>
                    <img src={reportes}/>
                </div>
                <div className='contenedorDescripcionNominaBImagen'>
                    <p>Reportes</p>
                </div>
            </div>

            <div className='contenedorConjunto'>
                <div className='contenedorImagenDescripcionNominaB'>
                    <img src={tools}/>
                </div>
                <div className='contenedorDescripcionNominaBImagen'>
                    <p>Herramientas</p>
                </div>
            </div>
        </div>
    </div>
</div>
    </>)
}